import { useEffect, useState } from "react";
import AddNewLocation from '../../Setup/Account/Location/AddNewLocation'
import AddNewProvider from '../../Setup/Account/Provider/AddNewProvider'
import AddNewInsurance from "../../Setup/InsuranceM/Insurance/AddNewInsurance";
import AddNewPOS from "../../Setup/Coding/POS/AddNewPOS";
import AddNewModifier from "../../Setup/Coding/Modifiers/AddNewModifier";
import AddNewDiagnosis from "../../Setup/Coding/DiagnosisCode/AddNewDiagnosis";
import AddNewInsuranceTypeCode from "../../Setup/InsuranceM/InsuranceType/AddNewInsuranceTypeCode";
import AddNewInsuranceCategory from "../../Setup/InsuranceM/InsurranceCategory/AddNewInsurranceCategory";
import AddNewProcedureCodes from "../../Setup/Coding/ProcedureCode/AddNewProcedureCodes";
import AddNewRefProvider from "../../Setup/Account/RefProvider/AddNewRefProvider";
import AddNewBillingProvider from "../../Setup/Account/BillingProvider/AddNewBillingProvider";
import AddNewUser from "../../Setup/UserManagement/User/AddNewUser";
import AddNewTask from "../../Home/TaskManagement/AddNewTask";
import AddNewAppointment from "../../Scheduler/AddNewAppointment";

const OpenQuickPopup = ({ ID, name, setPopup, popupName, type, SelectedType }) => {
    const [IsOpenPopup, setIsOpenPopup] = useState(false);
    const [npiModal, setNpiModal] = useState(false)

    /////////////////////
    const handleOpenPopup = () => {
        setIsOpenPopup(true)
        setNpiModal(true)
    }
    const ClosePopup = () => {
        setIsOpenPopup(false)
        setNpiModal(false)
        setPopup(<></>)
    }
    const DeletePopup = () => {
        setIsOpenPopup(false)
        setPopup(<></>)
    }
    const proceedHeader = () => {
        return <p className="heading">Proceed with NPI Registry</p>;
    };
    const onCloseProocedNpi = () => {
        setNpiModal(false);
    }
    if (IsOpenPopup) {
        switch (popupName) {
            case 'Location':
                setPopup(<AddNewLocation LocationID={ID} isOpenLocation={IsOpenPopup} onClose={ClosePopup} onDeleteLocation={DeletePopup} />);
                break;

            case 'Provider':
                setPopup(<AddNewProvider ProviderID={ID} isOpenProvider={IsOpenPopup} onClose={ClosePopup} onDeleteProvider={DeletePopup}  />);
                break;

            case 'RefProvider':
                setPopup(<AddNewRefProvider RefProviderID={ID} isOpenRefProvider={IsOpenPopup} onClose={ClosePopup} onDeleteProvider={DeletePopup} />);
                break;

            case 'BillingProvider':
                setPopup(<AddNewBillingProvider BillingProviderID={ID} IsOpenBillingProvider={IsOpenPopup} onClose={ClosePopup} onDeleteProvider={DeletePopup} />);
                break;

            case 'Insurance':
                setPopup(<AddNewInsurance InsuranceID={ID} IsOpenInsurance={IsOpenPopup} onClose={ClosePopup} onDeleteInsurance={DeletePopup} />);
                break;


            case 'POS':
                setPopup(<AddNewPOS POSCode={ID} isOpenPOS={IsOpenPopup} onClose={ClosePopup} onDeletePOS={DeletePopup} />);
                break;

            case 'Diagnosis':
                setPopup(<AddNewDiagnosis DiagnosisCode={ID} isOpenDiagnosis={IsOpenPopup} onClose={ClosePopup} onDeleteDiagnosis={DeletePopup} />);
                break;

            case 'Procedure':
                setPopup(<AddNewProcedureCodes ProcedureCode={ID} isOpenProcedure={IsOpenPopup} onClose={ClosePopup} onDeleteProcedure={DeletePopup} />);
                break;

            case 'Modifier':
            case 'Modifiers':
                setPopup(<AddNewModifier ModifierCode={ID} isOpenModifier={IsOpenPopup} onClose={ClosePopup} onDeleteModifier={DeletePopup} />);
                break;

            case 'Procedure Macro':
                setPopup(<AddNewDiagnosis DiagnosisCode={ID} isOpenDiagnosis={IsOpenPopup} onClose={ClosePopup} onDeleteDiagnosis={DeletePopup} />);
                break;

            case 'Insurance Type':
                setPopup(<AddNewInsuranceTypeCode InsuranceID={ID} isOpenInsuranceType={IsOpenPopup} onClose={ClosePopup} onDeleteDiagnosis={DeletePopup} />);
                break;

            case 'Insurrance Category':
                setPopup(<AddNewInsuranceCategory InsuranceCategoryID={ID} IsOpenInsuranceCategory={IsOpenPopup} onClose={ClosePopup} onDeleteInuranceC={DeletePopup} />);
                break;

            case 'User':
                setPopup(<AddNewUser UserID={ID} isOpenUser={IsOpenPopup} onClose={ClosePopup} onDeleteUser={DeletePopup} />);
                break;

            case 'Task':
                setPopup(<AddNewTask Task={ID} IsOpen={IsOpenPopup} IsClosed={ClosePopup} onDeleteTask={DeletePopup} />);
                break;

            case 'Appointment':
                setPopup(<AddNewAppointment AppointmentID={ID} showEvents={IsOpenPopup} SelectedTypeProps={SelectedType} handleOnClose={ClosePopup} />);
                break;

            default:
                break;
        }

    }
    //// previevs code 

    // if (type === "GlobalInstantSearch") {
    //     handleOpenPopup();
    // }

    ///////////////////

    ///    add these things due to rending issue 
    //////new code /////////
    useEffect(() => {
        if (type === "GlobalInstantSearch" || popupName === "ProviderFromQuickAdd") {
            handleOpenPopup();
        }
    }, [type, popupName]);
    let provider = ""
    if (popupName === "ProviderFromQuickAdd") {
        if (IsOpenPopup) {
            provider = <AddNewProvider ProviderID={ID} isOpenProvider={IsOpenPopup} onClose={ClosePopup} onDeleteProvider={DeletePopup} npiModal={npiModal} proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} />

        }
    }
      let Location = ""
    if (popupName === "LocationFromQuickAdd") {
        if (IsOpenPopup) {
            Location = <AddNewLocation LocationID={ID} isOpenLocation={IsOpenPopup} onClose={ClosePopup} onDeleteLocation={DeletePopup} npiModal={npiModal} proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} />

        }
    }
    ////////////////////////
    return (<>
        {provider}
        {Location}

        <>

            {
                type === "AddIcon" ?
                    <div className="label-head">
                        <button class="btn-icon-circle btn-xs" onClick={handleOpenPopup}><i class="icon-plus-icon"></i></button>
                    </div>
                    : type === "Label" ?
                        <label onClick={handleOpenPopup}>{name}</label>
                        : type === "GlobalInstantSearch" ?
                            null :
                            <div className='slim_link_hover' onClick={() => handleOpenPopup()}> {name}</div>

            }
        </>


    </>);
}

export default OpenQuickPopup;